require('./brokerLastResultMiFIDInfoColumn.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const moment = require('moment');

// @commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @constants
const { DATE_FORMAT_COMPLETE, DATE_FORMAT_API2 } = require('constants/index');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');


class BrokerLastResultMiFIDInfoColumn extends React.Component {
    render() {
        const {
            dateLastPerformedTest,
            dateLastPerformedTestFormat,
            evaluationDescription
        } = this.props;

        const formattedDate = DateHelper.buildFormattedDate(
            moment(dateLastPerformedTest, dateLastPerformedTestFormat),
            DATE_FORMAT_COMPLETE
        );

        return (
            <OKSectionBox>
                <div className="broker-last-result-mifid-info-column__title">
                    <FormattedText value="consultMiFID-evaluationResult" format="uppercase" />
                </div>
                {evaluationDescription}
                <div className="broker-last-result-mifid-info-column__date-title">
                    <FormattedText value="consultMiFID-dateLastTestCompleted" format="uppercase" />
                </div>
                <div className="broker-last-result-mifid-info-column__date-semibold">
                    {formattedDate}
                </div>
            </OKSectionBox>
        );
    }
}

BrokerLastResultMiFIDInfoColumn.propTypes = {
    dateLastPerformedTest: PropTypes.string,
    dateLastPerformedTestFormat: PropTypes.string,
    evaluationDescription: PropTypes.string,
};

BrokerLastResultMiFIDInfoColumn.defaultProps = {
    dateLastPerformedTestFormat: DATE_FORMAT_API2
};

module.exports = BrokerLastResultMiFIDInfoColumn;
